<template lang="pug">
  b-container.cellRow
    b-row(v-if="data_in || data_out")
      b-col(cols = "2").pl-0
        span.font-weight-bold(v-html="label")
      b-col
        span(v-if="data_in") {{ data_in.toLocaleString() }}
        span(v-else) None
        span.mr-1.ml-1 ->
        span(v-if="data_out") {{ data_out.toLocaleString() }}
        span(v-else) None
        span(v-html="unit").ml-1
</template>

<script>
export default {
  name: "tableCaseStudieRow",
  props: ['label', 'data_in', 'data_out','unit']
}
</script>

<style scoped>

</style>